/**
 * SubTabs — segmented control shared by the Spending, Plan and You pages.
 */
import React from 'react';

export default function SubTabs({ tabs, active, onChange }) {
  return (
    <div className="subtabs">
      {tabs.map((t) => (
        <button
          key={t.id}
          className={'subtab' + (active === t.id ? ' on' : '')}
          onClick={() => onChange(t.id)}
        >
          {t.label}
        </button>
      ))}
    </div>
  );
}
